import React, { useState, useEffect, useRef, createRef, useContext } from "react";
import { Sidebar as ProSidebar, Menu, MenuItem, useProSidebar, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme, useMediaQuery, Popper, Grow, Paper, Avatar, Button, Switch, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { Link, NavLink, Navigate, useLocation } from "react-router-dom";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import ForestIcon from '@mui/icons-material/Forest';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BarChartIcon from '@mui/icons-material/BarChart';
import PublicIcon from '@mui/icons-material/Public';

import ChatIcon from '@mui/icons-material/Chat';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import InsightsIcon from '@mui/icons-material/Insights';
import { useDispatch, useSelector } from "react-redux";
import { setLeftMenu } from "../../state";

import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import CandlestickChartIcon from '@mui/icons-material/CandlestickChart';
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import LogoutIcon from "@mui/icons-material/Logout";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import LeftArrowSvg from '../../images/sidebar/sidebar-left.svg';
import RightArrowSvg from '../../images/sidebar/sidebar-right.svg';

import GroupsIcon from '@mui/icons-material/Groups';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import Cookies from "js-cookie";
import { styled } from '@mui/system';

import TimelineIcon from '@mui/icons-material/Timeline';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Profile from '@mui/icons-material/AccountCircle';

import { ColorModeContext } from "../../theme";

/* ================= INLINE ICONS ================= */
// ✅ ไอคอนมงกุฎ
const CrownIcon = ({ color, style }) => (
    <svg viewBox="0 0 24 24" style={{ width: '16px', height: '16px', pointerEvents: 'none', flexShrink: 0, ...style }} fill={color}>
        <path d="M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19H5V18H19V19Z" />
    </svg>
);


// ================= Item สำหรับเมนูที่มีมงกุฎ ================= //
const ItemNew1 = ({ title, to, icon, selected, setSelected, isMobile, user, permissionKey, IsSideBarAppear }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { collapseSidebar, collapsed } = useProSidebar();

    const handleItemClick = (event) => {
        setSelected(to);
        isMobile ? collapseSidebar(true) : collapseSidebar(false);
    };

    // เช็คสิทธิ์การใช้งาน
    let isSubscriber = false;
    if (
        !user ||
        !user.permissions ||
        !user.permissions.permission ||
        !user.permissions.permission[permissionKey] ||
        !user.permissions.permission[permissionKey].read
    ) {
        isSubscriber = true;
    }

    const isUnlocked = !isSubscriber;
    const isActive = selected === to;

    // ✅ ปรับสีเริ่มต้นเป็นสีขาวทั้งหมด (ถ้า Active และ Unlocked ถึงจะเป็นสีทอง)
    const dynamicTextColor = isActive 
        ? (isUnlocked ? "#ffcc00" : "#ffffff") 
        : "#ffffff"; // เปลี่ยนจากสีเทาเป็นสีขาว

    const textStyle = {
        fontSize: IsSideBarAppear ? '0.95rem' : '0.8rem',
        textAlign: IsSideBarAppear ? 'normal' : 'center',
        fontFamily: 'Sora, sans-serif',
        fontWeight: isActive ? '500' : '300',
        fontStyle: 'normal',
        display: 'flex',
        flexDirection: IsSideBarAppear ? 'row' : 'column',
        alignItems: 'center',
        justifyContent: IsSideBarAppear ? 'flex-start' : 'center',
        gap: IsSideBarAppear ? '1rem' : '4px',
        color: 'inherit',
    };

    const Ribbon = styled('div')(({ theme }) => ({
        right: IsSideBarAppear ? '1vw' : '0vw',
        width: '50px',
        height: '50px',
        backgroundColor: 'red',
        color: 'white',
        position: 'absolute',
        top: '0rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.5rem',
        fontWeight: '300',
        zIndex: 1,
        [theme.breakpoints.up('sm')]: {
            width: IsSideBarAppear ? '60px' : '50px',
            height: IsSideBarAppear ? '20px' : '15px',
            fontSize: IsSideBarAppear ? '0.45rem' : '0.55rem',
        },
        [theme.breakpoints.up('md')]: {
            width: IsSideBarAppear ? '60px' : '50px',
            height: IsSideBarAppear ? '20px' : '15px',
            fontSize: '0.55rem',
        },
        [theme.breakpoints.up('lg')]: {
            width: IsSideBarAppear ? '70px' : '50px',
            height: IsSideBarAppear ? '20px' : '15px',
            fontSize: IsSideBarAppear ? '0.7rem' : '0.55rem',
        },
    }));

    const NavLinkWithRibbon = styled(NavLink)(({ theme }) => ({
        position: 'relative',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        marginTop: '3px'
    }));

    const StyledBox = styled(Box)(({ theme, selected, title, colors }) => ({
        backgroundColor: isActive ? '#111827' : 'transparent',
        borderRadius: IsSideBarAppear ? '15px 0 0 15px' : '20px 0 0 20px',
        color: `${dynamicTextColor} !important`,

        position: 'relative',
        width: '100%',
        padding: IsSideBarAppear ? '1.2vh 4rem 1.2vh 2.5vw' : '1vh 1rem 1vh 1vw',
        [theme.breakpoints.between('sm', '770')]: { padding: IsSideBarAppear ? '1.3vh 3.5rem 1.3vh 3.2vw' : '0.8vh 0rem 0.8vh 0vw' },
        [theme.breakpoints.between('sm', '900')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 3vw' : '0.7vh 0rem 0.7vh 0vw' },
        [theme.breakpoints.between('md', '1030')]: { padding: IsSideBarAppear ? '0.7vh 1rem 0.7vh 2.2vw' : '0.5vh 0rem 0.5vh 0vw' },
        [theme.breakpoints.between('md', '1200')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 3.4vw' : '0.7vh 0rem 0.7vh 0vw' },
        [theme.breakpoints.between('md', '1270')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 2vw' : '0.7vh 0rem 0.7vh 0vw' },
        [theme.breakpoints.between('lg', '1370')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 2vw' : '0.8vh 0rem 0.8vh 0vw' },
        [theme.breakpoints.up('lg', '1400')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 1.5vw' : '0.8vh 0rem 0.8vh 0vw' },

        display: 'flex',
        alignItems: 'center',
        justifyContent: IsSideBarAppear ? 'space-between' : 'center',
        flexDirection: 'row',
        transition: 'all 0.2s',
        ':hover': {
            backgroundColor: isActive ? '#111827' : 'rgba(255, 255, 255, 0.05)',
            color: isUnlocked ? '#ffcc00 !important' : '#ffffff !important',
            borderRadius: IsSideBarAppear ? '15px 0 0 15px' : '20px 0 0 20px',
        }
    }));

    return (
        <NavLinkWithRibbon to={isSubscriber ? 'upgrade' : to} style={{
            position: 'relative',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            left: IsSideBarAppear ? '1vw' : '0vw'
        }}>
            <StyledBox selected={selected} title={title} colors={colors} onClick={handleItemClick}>
                <Box sx={{ display: 'flex', flexDirection: IsSideBarAppear ? 'row' : 'column', alignItems: 'center', gap: IsSideBarAppear ? '10px' : '0px', color: 'inherit' }}>
                    <span style={{ display: 'flex', alignItems: 'center', color: 'inherit' }}>{icon}</span>
                    <Typography style={textStyle}>{title}</Typography>
                </Box>

                {/* ✅ แสดง CrownIcon เฉพาะตอนกาง Sidebar และขยับมาซ้าย (marginRight) */}
                {IsSideBarAppear && <CrownIcon color="#facc15" style={{ marginLeft: '10px', marginRight: '15px' }} />}

                {isSubscriber && <Ribbon>Subscription</Ribbon>}
            </StyledBox>
        </NavLinkWithRibbon >
    );
};


// ================= Item สำหรับเมนูที่ *ไม่มี* มงกุฎ ================= //
// (ตัดลอจิก Subscription และ CrownIcon ออกทั้งหมด)
const ItemNoCrown = ({ title, to, icon, selected, setSelected, isMobile, IsSideBarAppear, onClickAction }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { collapseSidebar, collapsed } = useProSidebar();

    const handleItemClick = (event) => {
        if (onClickAction) {
            onClickAction(event); // รันฟังก์ชันพิเศษถ้ามี (เช่น Logout)
        } else {
            setSelected(to);
        }
        if (isMobile) collapseSidebar(true);
    };

    const isActive = selected === to;
    
    // สีเริ่มต้นเป็นขาว (ถ้า Active ก็ให้เป็นสีทองได้เลย เพราะไม่มีเงื่อนไขปลดล็อค)
    const dynamicTextColor = isActive ? "#ffcc00" : "#ffffff";

    const textStyle = {
        fontSize: IsSideBarAppear ? '0.95rem' : '0.8rem',
        textAlign: IsSideBarAppear ? 'normal' : 'center',
        fontFamily: 'Sora, sans-serif',
        fontWeight: isActive ? '500' : '300',
        fontStyle: 'normal',
        display: 'flex',
        flexDirection: IsSideBarAppear ? 'row' : 'column',
        alignItems: 'center',
        justifyContent: IsSideBarAppear ? 'flex-start' : 'center',
        gap: IsSideBarAppear ? '1rem' : '4px',
        color: 'inherit',
    };

    const NavLinkWithRibbon = styled(to === "#" ? Box : NavLink)(({ theme }) => ({
        position: 'relative',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        marginTop: '3px',
        cursor: to === "#" ? "pointer" : "pointer",
        width: '100%'
    }));

    const StyledBox = styled(Box)(({ theme, selected, title, colors }) => ({
        backgroundColor: isActive ? '#111827' : 'transparent',
        borderRadius: IsSideBarAppear ? '15px 0 0 15px' : '20px 0 0 20px',
        color: `${dynamicTextColor} !important`,

        position: 'relative',
        width: '100%',
        padding: IsSideBarAppear ? '1.2vh 4rem 1.2vh 2.5vw' : '1vh 1rem 1vh 1vw',
        [theme.breakpoints.between('sm', '770')]: { padding: IsSideBarAppear ? '1.3vh 3.5rem 1.3vh 3.2vw' : '0.8vh 0rem 0.8vh 0vw' },
        [theme.breakpoints.between('sm', '900')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 3vw' : '0.7vh 0rem 0.7vh 0vw' },
        [theme.breakpoints.between('md', '1030')]: { padding: IsSideBarAppear ? '0.7vh 1rem 0.7vh 2.2vw' : '0.5vh 0rem 0.5vh 0vw' },
        [theme.breakpoints.between('md', '1200')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 3.4vw' : '0.7vh 0rem 0.7vh 0vw' },
        [theme.breakpoints.between('md', '1270')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 2vw' : '0.7vh 0rem 0.7vh 0vw' },
        [theme.breakpoints.between('lg', '1370')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 2vw' : '0.8vh 0rem 0.8vh 0vw' },
        [theme.breakpoints.up('lg', '1400')]: { padding: IsSideBarAppear ? '1vh 1rem 1vh 1.5vw' : '0.8vh 0rem 0.8vh 0vw' },

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', // ไม่ต้องใช้ space-between แล้วเพราะไม่มีมงกุฎ
        flexDirection: 'row',
        transition: 'all 0.2s',
        ':hover': {
            backgroundColor: isActive ? '#111827' : 'rgba(255, 255, 255, 0.05)',
            color: '#ffcc00 !important',
            borderRadius: IsSideBarAppear ? '15px 0 0 15px' : '20px 0 0 20px',
        }
    }));

    return (
        <NavLinkWithRibbon to={to} style={{
            position: 'relative',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            left: IsSideBarAppear ? '1vw' : '0vw'
        }}>
            <StyledBox selected={selected} title={title} colors={colors} onClick={handleItemClick}>
                <Box sx={{ display: 'flex', flexDirection: IsSideBarAppear ? 'row' : 'column', alignItems: 'center', gap: IsSideBarAppear ? '10px' : '0px', color: 'inherit' }}>
                    <span style={{ display: 'flex', alignItems: 'center', color: 'inherit' }}>{icon}</span>
                    <Typography style={textStyle}>{title}</Typography>
                </Box>
            </StyledBox>
        </NavLinkWithRibbon >
    );
};


const ListItemLink = (props) => {
    const { icon, primary, to, itemStyle } = props;

    return (
        <li>
            <ListItem button component={Link} to={to}>
                {icon ? icon : null}
                <ListItemText primary={primary} style={{ ...itemStyle, marginLeft: '8px' }} />
            </ListItem>
        </li>
    );
}

const SideBarV2 = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const location = useLocation();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [selected, setSelected] = useState(location.pathname);

    const { collapseSidebar, collapsed } = useProSidebar();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const leftMenuSelect = useSelector((state) => state.leftMenu);
    const userDetail = useSelector((state) => state.userDetail);

    const { toggleColorMode } = useContext(ColorModeContext);
    const [isChecked, setIsChecked] = useState(theme.palette.mode === "dark");

    const handleToggle = () => {
        setIsChecked(!isChecked);
        toggleColorMode();
    };

    //new width model
    const sidebarWidths = {
        active: {
            [theme.breakpoints.up('lg', '1400')]: { width: '15vw', position: 'relative', overflowX: 'hidden', transition: 'width 0.25s' },
            [theme.breakpoints.between('lg', '1370')]: { width: '15vw', position: 'relative', overflowX: 'hidden', transition: 'width 0.25s' },
            [theme.breakpoints.between('md', '1200')]: { width: '18vw', position: 'relative', overflowX: 'hidden', transition: 'width 0.25s' },
            [theme.breakpoints.between('md', '1030')]: { width: '20vw', position: 'relative', overflowX: 'hidden', transition: 'width 0.25s' },
            [theme.breakpoints.between('sm', '900')]: { width: '25vw', position: 'relative', overflowX: 'hidden', transition: 'width 0.25s' },
            [theme.breakpoints.between('sm', '770')]: { width: '31vw', position: 'relative', overflowX: 'hidden', transition: 'width 0.25s' },
        },
        inactive: {
            width: '5rem',
            transition: 'width 0.25s'
        }
    };

    const [SideBarActive, setSideBarActive] = useState(sidebarWidths.active);
    const [IsSideBarAppear, setIsSideBarAppear] = useState(true);

    useEffect(() => {
        const savedSidebarState = localStorage.getItem('sidebarState');
        if (savedSidebarState) {
            const parsedState = JSON.parse(savedSidebarState);
            setIsSideBarAppear(parsedState.IsSideBarAppear);
            setSideBarActive(parsedState.sideBarActive);
        }
    }, []);
    
    const hideSideBar = () => {
        setIsSideBarAppear(false)
        setSideBarActive(!sidebarWidths.inactive);
        localStorage.setItem('sidebarState', JSON.stringify({
            IsSideBarAppear: false,
            sideBarActive: false,
        }));
    };

    const showSideBar = () => {
        setIsSideBarAppear(true)
        setSideBarActive(!sidebarWidths.active);
        localStorage.setItem('sidebarState', JSON.stringify({
            IsSideBarAppear: true,
            sideBarActive: true,
        }));
    };

    useEffect(() => {
        isMobile ? collapseSidebar(true) : collapseSidebar(false);
    }, [isMobile]);

    const csrfToken = useSelector((state) => state.csrfToken);
    const isAuth = (Boolean(useSelector((state) => state.token))) && (Boolean(Cookies.get("access_token")));
    const userId = useSelector((state) => state.user);

    useEffect(() => {
    }, [userDetail]);


    const [isSidebarHovered, setIsSidebarHovered] = useState(false);
    const [isClickCollapsed, setIsClickCollapsed] = useState(false);
    const handleSidebar = () => {
        if (isSidebarHovered && !collapsed) {
            collapseSidebar(false);
            setIsSidebarHovered(false);
        } else {
            collapseSidebar();
            setIsSidebarHovered(!isSidebarHovered);
        }
        setIsClickCollapsed(false);
    }
    
    const handleMouseEnter = () => {
        setIsClickCollapsed(true);
        if (isClickCollapsed) {
            if (isSidebarHovered && collapsed) {
                collapseSidebar(false);
            }
        }
    };
    
    const handleMouseLeave = () => {
        if (isSidebarHovered && !collapsed) {
            collapseSidebar(true);
        }
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [open1, setOpen1] = useState(false);

    const handleOpen = () => {
        console.log('Modal opening');
        setOpen1(true);  // เปิด Modal
    };

    const handleClose1 = () => {
        setOpen1(false); // ปิด Modal
    };

    const handleConfirmLogout = () => {
        window.location.href = "/logout";
    };

    const [showDiv, setShowDiv] = useState(false);

    const toggleDiv = () => {
        setShowDiv(!showDiv);
    };

    const [divPosition, setDivPosition] = useState({ left: 0, top: 0 });
    const iconButtonRef = useRef();
    const sideDivRef = useRef();
    const sidebarRef = useRef(null);

    useEffect(() => {
        sidebarRef.current = sidebarRef.current;
    }, [sidebarRef]);

    useEffect(() => {
        if (showDiv && iconButtonRef.current) {
            const rect = iconButtonRef.current.getBoundingClientRect();
            setDivPosition({ left: rect.left + rect.width, top: rect.top + 5 });
        }
    }, [showDiv]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.target === sidebarRef.current) {
                    const width = entry.contentRect.width;
                    setDivPosition(prevData => ({
                        ...prevData,
                        left: width
                    }));
                    if (isSidebarHovered && !collapsed) {
                        if (showDiv && iconButtonRef.current) {
                            const rect = iconButtonRef.current.getBoundingClientRect();
                            setDivPosition({ left: rect.left + rect.width, top: rect.top + 5 });
                        }
                    }
                }
            }
        });

        if (sidebarRef.current) {
            resizeObserver.observe(sidebarRef.current);
        }
        return () => {
            resizeObserver.disconnect();
        };
    }, [collapsed]);


    return (
        <Box sx={{ position: 'relative' }}>

            <Box
                sx={{
                    "& .pro-sidebar-inner": {
                        background: "linear-gradient(to bottom, #0c0f14, #0a0d11) !important",
                    },
                    "& .pro-icon-wrapper": {
                        backgroundColor: "transparent !important",
                    },
                    "& .pro-inner-item": {
                        padding: "5px 35px 5px 20px !important",
                    },
                    "& .pro-inner-item:hover": {
                        color: "#868dfb !important",
                    },
                    "& .pro-menu-item.active": {
                        color: "#6870fa !important",
                    },

                    marginLeft: isSidebarHovered ? '3rem' : 0,
                    transition: 'margin-right 0.5s ease',
                }}
            >
                <Box
                    ref={sidebarRef}
                    collapsed={isCollapsed}

                    sx={{
                        background: 'linear-gradient(to bottom, #0c0f14, #0a0d11)',
                        borderRight: '1px solid rgba(255, 255, 255, 0.05)',
                        width: IsSideBarAppear ? sidebarWidths.active : sidebarWidths.inactive,
                        height: '100vh',
                        overflowY: 'auto',
                        '::-webkit-scrollbar': {
                            width: '0px',
                        },
                        zIndex: '100',
                        position: isSidebarHovered ? 'relative' : 'relative',
                        top: 0,
                        left: 0,
                    }}
                    collapsedWidth='3rem'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >

                    <Menu iconShape="square" width='100%' backgroundColor="transparent">
                        <Box
                            className="action-controls"
                            sx={{
                                padding: '1vh 1vw',
                                display: 'flex',
                                flexDirection: IsSideBarAppear ? 'row' : 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}>
                            
                            <Typography sx={{
                                color: 'white'
                            }} onClick={IsSideBarAppear ? hideSideBar : showSideBar}> {IsSideBarAppear ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />} </Typography>

                            <Switch
                                checked={isChecked}
                                onChange={handleToggle}
                                sx={{
                                    '& .MuiSwitch-thumb': {
                                        backgroundImage: isChecked ? 'linear-gradient(90deg, #8E8E8E, #413F3B)' : 'linear-gradient(90deg, #FEE8C1, #FFCD77)',
                                        transition: "background-color 0.5s ease-in-out",
                                        boxShadow: '0px 0px 3px 1px #888888',
                                    },
                                    '& .MuiSwitch-track': {
                                        backgroundColor: isChecked ? "#837E7E" : "#57CFFF",
                                        opacity: '1',
                                        boxShadow: isChecked ? '2px 1px 3px 0px inset #323232' : '1px 2px 3px 0px inset #ffffff',
                                        borderRadius: '40px',
                                    },
                                }}
                            />
                        </Box>

                        <Box className='sidebar-logo' sx={{ width: '100%', height: '100%' }}>
                            <Box variant="h2" color='black' overflow='visible'
                                sx={{
                                    width: '100%',
                                    position: 'relative',
                                    display: IsSideBarAppear ? 'flex' : 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    top: '0vh',
                                }}>
                                <img src="https://i.postimg.cc/TP1gJwyz/logo-white-02.png" alt="" width='70%' height='auto' />
                            </Box>
                        </Box>

                        <Divider sx={{
                            marginTop: '10px',
                            backgroundColor: '#FFCD77',
                            height: '0.1vh'
                        }} />

                        <Box className="list-items">
                            <Typography
                                variant="h5"
                                sx={{
                                    color: '#FFCD77',
                                    display: 'flex',
                                    justifyContent: IsSideBarAppear ? 'normal' : 'center',
                                    position: 'relative',
                                    left: IsSideBarAppear ? '1vw' : 'normal',
                                    fontSize: IsSideBarAppear ? '1rem' : '0.8rem',
                                    fontFamily: '"Sora", sans-serif',
                                    fontWeight: '400',
                                    padding: IsSideBarAppear ? '10px 0 10px 0' : '10px 0 10px 2px'
                                }}
                            >
                                Data
                            </Typography>

                            <ItemNew1 title='หมอดูหุ้น' to="/chatbot" icon={<ChatIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'chatBot9Chanel'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title='Petroleum' to="/petroleum" icon={<OilBarrelIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'petroleumChart'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title="Rubber Thai" to="/rubber" icon={<ForestIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'rubberThaiChart'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title="Flow Intraday" to="/realtime" icon={<SwapHorizIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'realTimeChart'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title='S50' to="/s50" icon={<ShowChartIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'chatBot9Chanel'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title="Gold" to="/gold" icon={<ViewTimelineIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'goldChart'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title="BidAsk" to="/dejavu/bidask" icon={<HandshakeIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'bidaskDejavu'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title="TickMatch" to="/dejavu/tickmatch" icon={<BarChartIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'tickmatchDejavu'} IsSideBarAppear={IsSideBarAppear} />
                            <ItemNew1 title="DR" to="/dr" icon={<PublicIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} user={userDetail} permissionKey={'tickmatchDejavu'} IsSideBarAppear={IsSideBarAppear} />

                            {userDetail.user_type == 'employee' && (<>
                                <Divider sx={{
                                    marginTop: '5px',
                                    backgroundColor: '#FFCD77',
                                    height: '0.1vh'
                                }} />
                                <Typography
                                    variant="h5"
                                    sx={{
                                        color: '#FFCD77',
                                        display: 'flex',
                                        justifyContent: IsSideBarAppear ? 'normal' : 'center',
                                        position: 'relative',
                                        left: IsSideBarAppear ? '1vw' : 'normal',
                                        fontSize: IsSideBarAppear ? '1rem' : '0.7rem',
                                        fontFamily: '"Sora", sans-serif',
                                        fontWeight: '400',
                                        padding: IsSideBarAppear ? '10px 0 10px 0' : '10px 0 10px 2px'
                                    }}
                                >
                                    Administrator
                                </Typography>
                            </>)}
                            
                            {/* ใช้ ItemNoCrown สำหรับส่วนที่ไม่อยากให้มีมงกุฎ */}
                            {userDetail.user_type === 'employee' && (
                                < ItemNoCrown title="Manage User" to="/admin/users" icon={<PeopleOutlinedIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} IsSideBarAppear={IsSideBarAppear} />
                            )}
                            {userDetail.user_type === 'employee' && (
                                < ItemNoCrown title="Manage Role" to="/admin/roles" icon={<GroupsIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} IsSideBarAppear={IsSideBarAppear} />
                            )}
                        </Box>

                        <Divider sx={{
                            marginTop: '5px',
                            backgroundColor: '#FFCD77',
                            height: '0.1vh'
                        }} />

                        <Box className="profile">
                            <Typography variant='5' sx={{
                                color: '#FFCD77',
                                display: 'flex',
                                justifyContent: IsSideBarAppear ? 'normal' : 'center',
                                position: 'relative',
                                left: IsSideBarAppear ? '1vw' : 'normal',
                                fontSize: IsSideBarAppear ? '1rem' : '0.8rem',
                                fontFamily: '"Sora", sans-serif',
                                fontWeight: '400',
                                padding: IsSideBarAppear ? '10px 0 10px 0' : '10px 0 10px 2px'
                            }}>
                                Account
                            </Typography>

                            {/* ใช้ ItemNoCrown สำหรับส่วนที่ไม่อยากให้มีมงกุฎ */}
                            <ItemNoCrown title="My Account" to="/profile" icon={<PersonOutlinedIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} IsSideBarAppear={IsSideBarAppear} />

                            <ItemNoCrown title="Logout" to="#" icon={<LogoutIcon />} selected={selected} setSelected={setSelected} isMobile={isMobile} IsSideBarAppear={IsSideBarAppear} onClickAction={handleOpen} />
                        </Box>
                    </Menu>
                </Box>
                
                <Dialog open={open1} onClose={handleClose1}>
                    <DialogTitle>< Typography variant='h4'>ออกจากระบบ?</Typography></DialogTitle>
                    <DialogContent>
                        Are you sure you want to logout?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose1} sx={{ color: theme.palette.text.primary }}>Cancel</Button>
                        <Button onClick={handleConfirmLogout} sx={{ backgroundColor: colors.redAccent[500], color: 'white' }}>Logout</Button>
                    </DialogActions>
                </Dialog>
                
                <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 99999 }}>
                    {showDiv && (
                        <Box className="sideDiv" sx={{ position: 'absolute', width: '200px', height: '150px', top: divPosition.top, left: divPosition.left, fontSize: '10px' }}>
                            <Card sx={{ minWidth: 275 }}>
                                <CardContent style={{ padding: 0 }}>
                                    <MenuList autoFocusItem={open} id="composition-menu" aria-labelledby="composition-button" style={{ padding: 0 }}>
                                        <li>
                                            <ListItem >
                                                <ListItemText primary={<Typography style={{ marginLeft: '8px' }} variant="h3" gutterBottom>IDEATRADE</Typography>} />
                                            </ListItem>
                                        </li>
                                        <Divider variant="middle" component="li" />
                                        <ListItemLink to="/profile" primary={<Typography>Account</Typography>} icon={<PersonOutlinedIcon />} />
                                        <ListItemLink to="/logout" primary={<Typography>Logout</Typography>} icon={<LogoutIcon style={{ color: 'red' }} />} itemStyle={{ color: 'red' }} />
                                    </MenuList>
                                </CardContent>
                            </Card>
                        </Box>
                    )}
                </div>
            </Box >
        </Box >
    );
};

export default SideBarV2;